/**
 * Vận chuyển chung của Nhật ký & Truy vết (module `audit`, ADR-0095) — port `apps/web-portal/src/modules/nhat-ky` của
 * native.
 *
 * Đường dẫn: native `/api/nhat-ky/<x>` → `/api/v1/m/audit/<x>` (cùng đường con, cùng tên trường snake_case, cùng con trỏ
 * trang). Bỏ `X-Tenant-ID` và mọi tham số tổ chức: tenant đã nằm trong phiên, audit-service đọc từ ngữ cảnh Gateway ký.
 * Tham số nhiều giá trị (`hanh_dong`, `muc_do`…) gửi một chuỗi nối bằng dấu phẩy — Spring tách thành danh sách.
 *
 * Màn Sử dụng AI của cổng tenant đọc qua `nktv-su-dung-ai.repository.ts`
 * dùng `goiAudit`; component không gọi tệp này trực tiếp (View → hook → repository → vận chuyển).
 *
 * **Chỉ API thật, không có máy chủ giả** — cùng lý do với `tro-ly-ai`, `tham-dinh`: backend viết trước giao diện.
 */
import { goiApi, type YeuCauApi } from '../api/http';

export const GOC_AUDIT = '/api/v1/m/audit';

/** Giá trị tham số query: mảng nối bằng dấu phẩy, rỗng thì bỏ. */
export type GiaTriQuery = string | number | boolean | readonly string[] | null | undefined;

export function thamSo(q: Record<string, GiaTriQuery>): Record<string, string | number | undefined> {
  const ra: Record<string, string | number | undefined> = {};
  for (const [k, v] of Object.entries(q)) {
    if (v === null || v === undefined || v === '') continue;
    if (Array.isArray(v)) {
      if (v.length) ra[k] = v.join(',');
    } else if (typeof v === 'boolean') {
      ra[k] = v ? 'true' : 'false';
    } else {
      ra[k] = v as string | number;
    }
  }
  return ra;
}

export interface YeuCauAudit extends Omit<YeuCauApi, 'query'> {
  query?: Record<string, GiaTriQuery>;
}

/** Gọi `/api/v1/m/audit<duongDan>`; lỗi là `ApiError` của `lib/errors.ts` như mọi lời gọi khác. */
export function goiAudit<T>(duongDan: string, yeuCau: YeuCauAudit = {}): Promise<T> {
  const { query, ...con } = yeuCau;
  return goiApi<T>(`${GOC_AUDIT}${duongDan}`, { ...con, ...(query ? { query: thamSo(query) } : {}) });
}

/** Trang theo con trỏ của native (`du_lieu`, `con_tro_tiep`, `con_nua`). */
export interface TrangAudit<T> {
  du_lieu: T[];
  con_tro_tiep: string | null;
  con_nua: boolean;
}
